module.exports = __webpack_public_path__ + "static/media/photolab.d35e1879.png";